// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"38a9b8b6","48":"469dadb1","382":"45441b57","427":"8d1c81a7","431":"5bdc7ecd","473":"cd3a5a08","480":"2131b7c1","563":"ce99c72c","645":"4d180628","774":"d47937ae","790":"2ac933e5"}[chunkId] + ".chunk.js";
};